
import Popup from 'vux/src/components/popup/index.vue'

import api from '@/api'
import { mapGetters, mapActions } from 'vuex'

export default {
props: {
value: null
},
components: {
Popup
},
data: () => ({
show: false,
currentValue: {
city: '',
cityid: ''
},
currentLocation: {
city: '定位中...',
cityid: null
},
height: null
}),
computed: mapGetters({
currentCity: 'currentCity',
list: 'cityList'
}),
created () {
this.height = 'height:' + document.documentElement.clientHeight + 'px'
this.$nextTick(() => {
this.getGeoLocation()
this.initCityList()
})
},
methods: {
...mapActions({
save2store: 'saveCityList',
saveCurrentCity: 'saveCurrentCity'
}),
initCityList () {
if (!this.cityList) {
this.getCityList()
}
},
getCityList () {

this.axios.get(api.city.list).then(response => {
if (response.data.code === 200) {
var lists = response.data.data.list
for (var key in lists) {
for (var keys in lists[key].citylist) {
if (lists[key].citylist[keys].is_open === '0') {
lists[key].citylist[keys] = {}
}
}
}
this.save2store({ list: lists })
}
})
},
setCurrentCity (city) {
this.show = false
this.saveCurrentCity(city) 
},
getGeoLocation () {

navigator.geolocation.getCurrentPosition(position => {
if (position.coords) {
this.axios.get(api.common.currentLocation, {params: {
lat: position.coords.latitude,
lng: position.coords.longitude
}})
.then(response => {
if (response.data.code === 200) {
this.currentLocation = response.data.data
}
})
}
}, error => {
this.currentLocation = {
city: '定位失败',
cityid: null
}
return error

})
},
open () {
this.show = true
},
close () {
this.show = false
},
onOpen () {
console.log('onOpen')
},
onClose () {
console.log('onClose')
this.$emit('on-close', this.currentValue)
}
},
watch: {
value (val) {
},
show (val) {
this[val ? 'onOpen' : 'onClose']()
}
}
}



// WEBPACK FOOTER //
// ./src/components/city-picker/index.vue